import { render } from "./EmailGatheringModal.vue?vue&type=template&id=70b03eee&scoped=true"
import script from "./EmailGatheringModal.vue?vue&type=script&lang=ts"
export * from "./EmailGatheringModal.vue?vue&type=script&lang=ts"

import "./EmailGatheringModal.vue?vue&type=style&index=0&id=70b03eee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70b03eee"

export default script